<template>
  <v-content>
    <v-card flat class="mx-3 mt-2 pa-2">
      <v-card-title class="pa-2">{{footpathTail}}</v-card-title>
      <!-- ダッシュボード表示箇所 -->
      <v-card class="ma-2" flat>
        <v-container>
          <v-row justify="center" align-content="center">
            <v-col cols="6" v-if="loading">
              <v-progress-linear
                color="indigo"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </v-col>
            <iframe :src="dashboardUrl" frameborder="0" width="100%" :height="listHeight" name="dashboard"></iframe>
          </v-row>
        </v-container>
      </v-card>
    </v-card>
  </v-content>
</template>

<script>
import myAxios from '../../../axios/myAxios.js'
import MsgList from '../../modules/MsgList'
import MstrHedr from '../../modules/MstrHedr'

export default {
  components: {
    MstrHedr
  },
  name: 'Dashboard',
  data () {
    return {
      loading: true,
      drawer: null,
      dialog: false,
      masterKanriFlg: false,
      userInfo: false,
      sideMenuItems: [],
      listHeight: 700,
      user: {
        user_cd: '',
        name: '',
        email_addr: '',
        kngn_typ: '',
        kiyk_cd: ''
      },
      kiyk_nm: '',
      kki_nm: '',
      dashboardUrl: 'about:blank',
      mainMenuFlg: false
    }
  },
  created () {
    // ログインセッションの確認
    myAxios.get('/api/common/session_manager', {type: 'isLogin'}).then(res => {
      const status = res.data.status
      const result = res.data.result

      // ログインセッションを確認できなければログイン画面に遷移する
      if (!(status && result)) {
        alert(MsgList.MSG_SES_CANNOT_CONFIRM)
        this.$router.push('/')
      }

      // ユーザinfoポップアップ用の情報を取得
      myAxios.get('/api/common/session_manager', {type: 'userinfo_popup'}).then(res => {
        const status = res.data.status
        const result = res.data.result

        if (status && result) {
          this.user.name = res.data.name
          this.user.email_addr = res.data.email_addr
          this.user.user_cd = res.data.user_cd
        }
      })
      // フットパスの設定
      myAxios.get('/api/common/session_manager', {type: 'kiyk_single_flg'}).then(res => {
        const status = res.data.status
        const result = res.data.result

        if (status) {
          this.mainMenuFlg = !result
        }
      })

      // 権限区分と契約コードの取得
      myAxios.get('/api/common/session_manager', {type: 'userinfo_kngn_kiyk'}).then(res => {
        const status = res.data.status
        const result = res.data.result

        if (status && result) {
          this.user.kngn_typ = res.data.kngn_typ
          this.user.kiyk_cd = res.data.kiyk_cd.trim()
          // サイドメニュー一覧を取得する
          myAxios.get('/api/dshbord/dashboard_menu', { kngn_typ: this.user.kngn_typ, kiyk_cd: this.user.kiyk_cd }).then(res => {
            this.sideMenuItems = res.data.dash_list_all[0]
          // eslint-disable-next-line handle-callback-err
          }).catch(err => {
            this.sideMenuItems = []
          })
        }
      })
    })
    // マスタ管理ボタン表示可否の取得
    myAxios.get('/api/login/kiyksk_sntk_master_kanri').then(res => {
      const status = res.data.status
      const result = res.data.result

      // 取得したマスタ管理フラグを設定する
      if (status) {
        this.masterKanriFlg = result
      }
    // eslint-disable-next-line handle-callback-err
    }).catch(err => {
      alert(this.connectionErrMsg)
      this.masterKanriFlg = false
    })
  },
  // 更新時に毎回呼び出される
  mounted () {
    this.onResize()
    this.changeListSize()
  },
  computed: {
    /**
     * フットパスを書き換える
     * URLのGetパラメータに連動してフットパスを書き換える
     */
    storeId () { return this.$store.getters['appSetting/selectId'] },
    storeKki () { return this.$store.getters['appSetting/selectKkiCd'] },
    footpathTail: function () {
      var storeId = this.$store.getters['appSetting/selectId']
      var storeKki = this.$store.getters['appSetting/selectKkiCd']
      let item = this.sideMenuItems.find((sideMenuItem) => {
        // eslint-disable-next-line eqeqeq
        return (sideMenuItem.id == storeId)
      })
      // ダッシュボードの情報を書き換える
      this.loadUrl(storeId, storeKki)

      // Getプロパティに取得可能なページ番号がなければ空を返す
      if (item) {
        return this.kki_nm + ' ' + item.name
      } else {
        return ''
      }
    },
    /**
     * ログインアカウントの監視対象件数に応じてヘッダーリンクの飛び先を切り替える
     */
    headerLink: function () {
      if (this.mainMenuFlg) {
        return '/KiykskSntk'
      } else {
        return '/Dshbord/Dshbord'
      }
    }
  },
  methods: {
    // 画面サイズ取得
    onResize () {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight }
    },
    // 一覧表示サイズを変更
    changeListSize () {
      this.listHeight = this.windowSize.y * 0.8
    },
    /**
     * メニューIDをサーバーに送信してQuickSightのダッシュボードURLを取得する
     */
    loadUrl (id, kki) {
      // ログインセッションの確認
      myAxios.get('/api/common/session_manager', {type: 'isLogin'}).then(res => {
        const status = res.data.status
        const result = res.data.result
        // ログインセッションを確認できなければログイン画面に遷移する
        if (!(status && result)) {
          alert(MsgList.MSG_SES_CANNOT_CONFIRM)
          this.$router.push('/')
        } else {
          this.$store.dispatch('appSetting/tLogin')
          // 読み込み
          myAxios.get('api/dshbord/dashboard_url', { kiyk_cd: this.user.kiyk_cd, mn_cd: id, kki_cd: kki }).then(res => {
            if (res.data.Status !== 200) {
              console.log('res.data.Status not 200')
              console.log(res.data.Status)
              if (res.data.Status !== 404) {
                alert('画像読み込みに失敗しました。管理者にお問い合わせください。')
              } else {
                console.log('res.data.Status is 404.')
                alert('画像読み込みに失敗しました。\n初期画面に戻ります。')
                this.$router.push('/initial')
              }
            } else if (res.data.Status === 403) {
              alert(MsgList.MSG_SES_CANNOT_CONFIRM)
              this.$router.push('/')
            } else {
              this.dashboardUrl = res.data.EmbedUrl
              this.kki_nm = res.data.kkiNm
              this.loading = false
            }
          // eslint-disable-next-line handle-callback-err
          }).catch(err => {
            console.log(err)
            console.log(res.data.Status)
            alert('画像読み込みに失敗しました。管理者にお問い合わせください。')
          })
        }
      })
    },
    // IFRAMEのsrc属性を破棄する
    resetUrl () {
      this.dashboardUrl = 'about:blank'
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/templates/Dshbord/DshbordCntnt.vue